import { Component } from '@angular/core';

@Component({
    selector: 'navigation-column',
    templateUrl: './navigation-column.component.html',
    styleUrls: ["./navigation-column.component.css"],
    standalone: false
})
export class NavigationColumnComponent {     
}